function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.513,12.413A3.865,3.865,0,1,1,13.6,9.731v1.16a1.16,1.16,0,1,0,2.319,0V9.731A6.184,6.184,0,1,0,12.1,15.451a.773.773,0,1,1,.6,1.422,7.73,7.73,0,1,1,4.77-7.143v1.16a2.706,2.706,0,0,1-4.947,1.523ZM9.73,12.05A2.319,2.319,0,1,0,7.411,9.731,2.319,2.319,0,0,0,9.73,12.05Z",
  transform: "translate(-2 -2.002)"
});

var SvgAt = function SvgAt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.461,
    height: 15.462,
    viewBox: "0 0 15.461 15.462"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/At.f91af2db.svg";
export { SvgAt as ReactComponent };